@import (reference) '../../../../constants/spacing.module.less';

.configure-shipment-section-header-actions {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.configure-shipment-section-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  gap: @space-16;
}

.configure-shipment-section-content {
  padding: @space-0;
}
